module.exports = __webpack_public_path__ + "img/clic_pub_rec_mobile_600.e0e0f0fe.png";